import { useCallback, useRef } from 'react'

// Debounce the received function by the specified delay in milliseconds
// Triggered everytime the return function is called
export function useDebounce(fn: () => void, delay: number) {
	const timeoutRef = useRef<number | null>(null)

	const debouncedFn = useCallback(() => {
		if (timeoutRef.current !== null) {
			clearTimeout(timeoutRef.current)
		}

		timeoutRef.current = window.setTimeout(fn, delay)
	}, [fn, delay])

	return debouncedFn
}
